import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type TestCallbackParams = {
    testCounter: number
};

export class PingMeIfAliveCommand extends JsToClientCommand<TestCallbackParams> {
    constructor() {
        super(ClientCommands.PING_ME_IF_ALIVE);
    }
}
